import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const test: ContentBlock<"test"> = {
  id: makeId("test-vitamin-d"),
  kind: "test",
  tags: ["testing", "her", "his", "both-partners", "pre-cycle", "optimization"],
  title: "Vitamin D",
  subtitle: "Vitamin D levels linked to fertility and implantation outcomes",
  body: {
    testName: "Vitamin D 25-OH",
    category: "blood-marker",
    whatItMeasures:
      "Vitamin D level, usually reported as 25-hydroxy vitamin D. Deficiency is common, correctable, and has been associated with fertility, implantation, and pregnancy outcomes in some studies.",
    howItWorks:
      "Simple blood draw, any lab. Can be done any day of cycle. Fasting is usually not required.",
    quickFacts: [
      { kind: "sample", value: "Blood" },
      { kind: "time", value: "5 min draw or home kit" },
      { kind: "pain", value: "Needle or lancet pinch" },
      { kind: "prep", value: "Any cycle day; no fasting usually" },
      { kind: "results", value: "2-5 business days" },
    ],
    turnaroundTime: "2-5 business days",
    costRange: { low: 30, high: 80 },
    atHome: true,
    labAvailable: true,
    clinicRequired: false,
    cycleDay: "Any cycle day",
    markerTiming: [
      {
        marker: "Vitamin D 25-OH",
        timing: "Any cycle day",
        reason:
          "Vitamin D status is not tied to a specific menstrual cycle day, so the same test can be used for baseline and follow-up tracking.",
      },
    ],
    whyItMatters: [
      "Vitamin D is one of the more actionable baseline markers because low levels can usually be corrected with supplementation.",
      "Some fertility programs aim above 40 ng/mL, although the exact target should be individualized to medical history and lab reference ranges.",
      "If starting or changing supplementation, many clinicians recheck after about 8 weeks.",
    ],
    dataPoints: [makeId("dp-vitamin-d-level")],
  },
  sources: [
    {
      title:
        "Vitamin D and assisted reproductive treatment outcome: a systematic review and meta-analysis",
      authors: "Chu J, Gallos I, Tobias A, Tan B, Eapen A, Coomarasamy A",
      journal: "Human Reproduction",
      year: 2018,
      url: "https://pubmed.ncbi.nlm.nih.gov/29149263/",
      evidenceLevel: "meta-analysis",
    },
  ],
  readTimeMinutes: 3,
};

registerBlock(test);
